/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IWidgetContainerData } from './widget-container.data';
import { ICardData, IWidgetContainerProps } from './widget-container.props.autogenerated';

export interface IWidgetContainerViewProps extends IWidgetContainerProps<IWidgetContainerData> {
    title?: string;
    description?: string;
    cards?: ICardData[];
}

/**
 *
 * WidgetContainer component
 * @extends {React.PureComponent<IWidgetContainerProps<IWidgetContainerData>>}
 */
class WidgetContainer extends React.PureComponent<IWidgetContainerProps<IWidgetContainerData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const viewProps = {
            ...this.props,
            title: config.title,
            description: config.description,
            cards: config.cards
        };
        return this.props.renderView(viewProps);
    }
}

export default WidgetContainer;
